import React from 'react';
import { Box, Flex, Text } from '@chakra-ui/react';
import { ReactComponent as CloseIcon } from '../../assets/images/icons/mevo/ic-exit-rounded-purple.svg';
import { ReactComponent as AlertIcon } from '../../assets/images/psp/alert.svg';
import { Button } from '../UI-CHAKRA/Button';
import { FreeSampleErrorContent } from '../../interfaces/freeSample';

interface FreeSampleErrorStepProps {
  // Erro conhecido (ver FREE_SAMPLE_KNOWN_REQUEST_ERRORS); ausente = texto genérico de instabilidade.
  content?: FreeSampleErrorContent | null;
  onClose: () => void;
}

const FreeSampleErrorStep: React.FC<FreeSampleErrorStepProps> = ({ content, onClose }) => {
  return (
    <Flex flexDirection={'column'} height={'100%'} overflow="hidden">
      <Box flexShrink={0} borderBottom={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} justifyContent={'space-between'} alignItems={'center'} padding={'20px'}>
          <Text fontSize={'18px'} fontWeight={700} color={'#343A40'}>
            Amostra grátis
          </Text>
          <CloseIcon onClick={onClose} cursor={'pointer'} />
        </Flex>
      </Box>

      <Box flexGrow={1} overflowY={'auto'} overflowX="hidden" padding={'120px 15px 15px 15px'}>
        <Flex flexDirection={'column'} alignItems={'center'} justifyContent={'center'} gap={'24px'} minH={'400px'}>
          <Box width={'150px'} height={'150px'} borderRadius={'50%'} display={'flex'} alignItems={'center'} justifyContent={'center'}>
            <AlertIcon width={'150px'} height={'150px'} />
          </Box>

          <Text fontSize={'32px'} fontWeight={700} color={'primary.main'} textAlign={'center'}>
            {content ? (
              content.title
            ) : (
              <>
                Não foi possível enviar <br />a solicitação
              </>
            )}
          </Text>

          <Text fontSize={'14px'} color={'#3D0E6B'} textAlign={'center'} maxW={'400px'}>
            {content ? content.description : 'Estamos enfrentando uma instabilidade. Tente novamente em alguns minutos.'}
          </Text>
        </Flex>
      </Box>

      <Box flexShrink={0} padding={'20px'} borderTop={'1px solid #E9ECEF'}>
        <Flex flexDirection={'row'} gap={'12px'} justifyContent={'flex-end'}>
          <Button
            onClick={onClose}
            padding="10px 20px"
            backgroundColor={'#FFF'}
            borderWidth={'2px'}
            borderColor={'primary.main'}
            borderStyle={'solid'}
            borderRadius={'20px'}
            _hover={{ backgroundColor: '#FFF', borderColor: '#6B409C' }}
          >
            <Text fontSize={'14px'} color={'primary.main'}>
              Fechar
            </Text>
          </Button>
        </Flex>
      </Box>
    </Flex>
  );
};

export default FreeSampleErrorStep;
